export type TBooleanStr = 'true' | 'false'

export const BOOLEAN = {
  TRUE: 'true',
  FALSE: 'false'
}

export const stringIsBoolean = (str = ''): boolean => {
  if (str) return str === BOOLEAN.TRUE || str === BOOLEAN.FALSE
  return false
}

export const stringToBoolean = (str: TBooleanStr = 'false'): boolean => {
  return str === BOOLEAN.TRUE
}
